import { cn } from '@xhubio-saas/core-frontend/ui-components'
import { CONTROL_TRANSITION, FIELD_RING } from '../../auth/authUi'

/** Shared range presets for the dashboard widgets (day granularity). */
export const RANGE_PRESETS = [7, 30, 90] as const
export type RangeDays = (typeof RANGE_PRESETS)[number]

/** Segmented-control button — shared look for range/view toggles on the
 * dashboard (and consistent with the settings-nav pills). */
export const SEGMENT_BUTTON = (active: boolean) =>
  cn(
    'rounded-md px-3 py-1 text-sm',
    CONTROL_TRANSITION,
    FIELD_RING,
    active ? 'bg-accent font-medium text-foreground' : 'text-muted-foreground hover:text-foreground'
  )
